module.exports = __webpack_public_path__ + "static/media/klima-12.4fe6937f.jpg";